import React from 'react';
import ContactForm from '../ContactFrom'

import cnt1 from '../../images/icon/home.svg'
import cnt2 from '../../images/icon/mail-2.svg'
import cnt3 from '../../images/icon/app.svg'

const Contactpage = () => {

    return(
        <section className="wpo-contact-pg-section section-padding">
            <div className="container">
                <div className="row">
                    <div className="col col-lg-10 offset-lg-1">
                        <div className="office-info">
                            <div className="row">
                                <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                                    <div className="office-info-item">
                                        <div className="office-info-icon">
                                            <div className="icon">
                                                <img src={cnt1} alt=""/>
                                            </div>
                                        </div>
                                        <div className="office-info-text">
                                            <h2>Direccion</h2>
                                            <p>CR 12 24 45 Cajica   Cundinamarca</p>
                                        </div>
                                    </div>
                                </div> 
                                <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                                    <div className="office-info-item">
                                        <div className="office-info-icon">
                                            <div className="icon">
                                                <img src={cnt2} alt=""/>
                                            </div>
                                        </div>
                                        <div className="office-info-text">
                                            <h2>Correo</h2>
                                            <p>jansprogramming@gmail.com</p>
                                        </div>
                                    </div>
                                </div> 
                                <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                                    <div className="office-info-item">
                                        <div className="office-info-icon">
                                            <div className="icon">
                                                <img src={cnt3} alt=""/>
                                            </div>
                                        </div>
                                        <div className="office-info-text">
                                            <h2>Telefonos</h2>
                                            <p>+57 333 646 3507</p>
                                        </div>
                                    </div>
                                </div> 
                            </div>
                        </div>
                        <div className="wpo-contact-title">
                            <h2>Tienes alguna consulta?</h2>
                            <p>Contactate con nosotros directamente.</p>
                        </div>
                        <div className="wpo-contact-form-area">
                            <ContactForm/>
                        </div>
                    </div>                
                </div>
            </div> 
            <section className="wpo-contact-map-section">
                <div className="wpo-contact-map">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3974.9896290235533!2d-74.02469472501919!3d4.941366695034698!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNMKwNTYnMjguOSJOIDc0wrAwMScxOS42Ilc!5e0!3m2!1ses-419!2sus!4v1738449454389!5m2!1ses-419!2sus"></iframe>
                </div>
            </section>
        </section>
     )
        
}

export default Contactpage;
